import React from 'react';
import { useAccess } from '../hooks/useAccess';

export const Guard = ({ children, policy, fallback = null }) => {
  const { canAccess, isReady } = useAccess();
  if (!isReady) return null;
  return canAccess(policy) ? <>{children}</> : fallback;
};
